// extracted by mini-css-extract-plugin
export default {"control":"Control_control__5m0XM","button":"Control_button__Z3uBi"};